import { appstr } from "@coreapp/utils/appstr";
import { Button, ButtonProps } from "@theorgchartdev/storybook";
import { useToolbarButtonTooltip } from "./useToolbarButtonTooltip";
import { useTableInstanceContext } from "@/providers/PlanningTabularProvider";

interface EditPositionProps extends ButtonProps {}

export const EditPosition = (props: EditPositionProps) => {
  const { selectedPositionsCount, isOnlyClosedPositionsSelected } = useTableInstanceContext();

  const noPositionSelected = selectedPositionsCount === 0;
  const onlyClosedPositionsSelected = isOnlyClosedPositionsSelected();
  const isDisabled = noPositionSelected || onlyClosedPositionsSelected;

  const tooltipProps = useToolbarButtonTooltip("edit");

  return (
    <Button
      {...props}
      disabled={isDisabled}
      iconProps={{
        name: "pen-to-square",
        title: "pen-to-square"
      }}
      modifier="primary"
      tooltipProps={tooltipProps}
    >
      {appstr("Edit position")}
    </Button>
  );
};
